@if (error) {
  <nk-error-alert [error]="error"></nk-error-alert>
}

@if (loading$ | async) {
  <nk-company-analysis-risk-loading
    [text]="'network_risk.loading_network_risk_score' | translate"></nk-company-analysis-risk-loading>
}

@if (networkRiskScoreData; as data) {
  <nk-company-analysis-risk-layout
    [attr.data-cy]="'company-analysis-network-risk-score'"
    [bgColor]="companyNetworkRiskScoreColor[data.networkRiskScoreCategory.result_category_key]"
    [printVersion]="printVersion()">
    <div class="d-flex align-items-top justify-content-between w-100" header>
      <div>
        <h1 class="mb-0" [attr.data-cy]="'company-analysis-network-risk-score-value'">
          {{ data.networkRiskScore.network_risk_score | number: '.1-2' }}
          <nk-risk-level-icon
            [attr.data-cy]="'company-analysis-network-risk-score-icon'"
            [riskLevel]="data.networkRiskScoreCategory.result_category_key"
            class="d-inline-block ms-1 fs-2"></nk-risk-level-icon>
        </h1>
        <p class="mb-0">
          {{ companyNetworkRiskScoreTranslations[data.networkRiskScoreCategory.result_category_key] | translate }}
        </p>
      </div>
    </div>
    <div body>
      <p class="text-muted text-uppercase">
        {{ 'network_risk.table.closest_network_contributors' | translate }}
      </p>
      <ul class="list-group list-group-flush" [attr.data-cy]="'company-analysis-network-risk-sources'">
        @if (allNetworkRiskScoreSourcesSorted; as dataSorted) {
          @for (source of dataSorted.slice(0, listSize); track source.entity_uuid) {
            <li
              class="list-group-item ps-0 pe-0 d-flex justify-content-between align-items-center"
              (click)="routerLinkClicked()">
              @switch (source.entity_key) {
                @case ('person') {
                  <a [routerLink]="['/person', source.entity_uuid]">
                    {{ source.entity_name }}
                  </a>
                }
                @case ('company') {
                  <a [routerLink]="['/company', source.entity_uuid]">
                    {{ source.entity_name | prettyCompanyName }}
                  </a>
                }
                @case ('geo_location') {
                  <a [routerLink]="['/address', source.entity_uuid]">
                    {{ source.entity_name }}
                  </a>
                }
                @case ('property') {
                  <a [routerLink]="['/property', source.entity_uuid]">
                    {{ source.entity_name }}
                  </a>
                }
                @case ('unverified_entity') {
                  {{ source.entity_name }}
                }
                @default {
                  {{ source.entity_name }}
                }
              }
              <span
                class="badge text-bg-{{
                  source.entity_contributing_score | networkRiskScoreRiskColorClass
                }} rounded-pill">
                {{ source.entity_contributing_score | number }}
              </span>
            </li>
          }
        }
      </ul>

      @if (displayShowMoreButton()) {
        <div class="text-center">
          @if (listSize < data.networkRiskScore.network_risk_sources.length) {
            <button [block]="true" nkButton size="sm" color="secondary" [ghost]="true" (click)="increaseList()">
              {{ 'network_risk.table.show_more' | translate }}
              <i class="ms-2 fa fa-caret-down"></i>
            </button>
          }
          @if (listSize >= data.networkRiskScore.network_risk_sources.length && listSize !== defaultListSize()) {
            <button [block]="true" nkButton size="sm" color="secondary" [ghost]="true" (click)="resetList()">
              {{ 'network_risk.table.show_less' | translate }}
              <i class="ms-2 fa fa-caret-up"></i>
            </button>
          }
        </div>
      }
    </div>
  </nk-company-analysis-risk-layout>
}
